// extracted by mini-css-extract-plugin
export default {"storychestColor":"#dc3151","dropdownMenuSelect":"dropdown_dropdownMenuSelect__agha+","dropdown-item":"dropdown_dropdown-item__hOB54"};